import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map } from 'lodash';

import SectionedItems from './../SectionedItems';

// image icons
import watchedPhone from '../../assets/images/icons/devices/phone-watchedon-icon.svg';
import watchedTablet from '../../assets/images/icons/devices/tablet-watchedon-icon.svg';
import watchedComputer from '../../assets/images/icons/devices/laptop-watchedon-icon.svg';
import watchedTv from '../../assets/images/icons/devices/tv-watchedon-icon.svg';

// expects an array with exactly 4 objects
const MobilityScores = props => {
  const { title, list, loading } = props;

  const watchedOnIcons = [
    {
      label: 'Phone',
      icon: watchedPhone
    },
    {
      label: 'Tablet',
      icon: watchedTablet
    },
    {
      label: 'Computer',
      icon: watchedComputer
    },
    {
      label: 'TV',
      icon: watchedTv
    }
  ];

  const listWithIcons = map(list, (el, idx) => ({
    ...el,
    icon: watchedOnIcons[idx].icon,
    label: watchedOnIcons[idx].label
  }));

  if (loading) {
    return (
      <div
        style={{
          width: '565px',
          height: '170px',
          borderRadius: '4px',
          border: 'solid 1px #c0c0c0',
          backgroundColor: '#ffffff'
        }}
      >
        <div className="tvt-time-chart__loading-state-wrapper mobility-score-loading">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="500"
            height="102"
            viewBox="0 0 500 102"
          >
            <defs>
              <linearGradient
                id="mbu0gmdmea"
                x1="0%"
                x2="100%"
                y1="50%"
                y2="50%"
              >
                <stop offset="0%" stopColor="#EEEEEE" />
                <stop offset="33%" stopColor="#EEEEEE" />
                <stop offset="50%" stopColor="#f5f5f5" />
                <stop offset="67%" stopColor="#EEEEEE" />
                <stop offset="100%" stopColor="#EEEEEE" />
                <animateTransform
                  attributeName="gradientTransform"
                  type="translate"
                  from="-1 0"
                  to="1 0"
                  begin="0s"
                  dur="1.5s"
                  repeatCount="indefinite"
                />
              </linearGradient>
            </defs>
            <path
              fill="url(#mbu0gmdmea)"
              fillRule="evenodd"
              d="M500 88v14h-72V88h72zm-143 0v14h-72V88h72zm-143 0v14h-72V88h72zM72 88v14H0V88h72zM393 0v102h-1V0h1zM250 0v102h-1V0h1zM107 0v102h-1V0h1zm393 58v26h-72V58h72zm-143 0v26h-72V58h72zm-143 0v26h-72V58h72zM72 58v26H0V58h72zM491 5v42h-54V5h54zM348 5v42h-54V5h54zM205 5v42h-54V5h54zM63 5v42H9V5h54z"
            />
          </svg>
        </div>
      </div>
    );
  }

  return (
    <SectionedItems
      hasSeparators
      title={title}
      loading={isEmpty(list)}
      list={listWithIcons}
    />
  );
};

MobilityScores.propTypes = {
  title: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired
    })
  ),
  loading: PropTypes.bool.isRequired
};

MobilityScores.defaultProps = {
  title: '',
  list: []
};

export default MobilityScores;
